import {commonTaskTemplate} from './commonTaskTemplate';

export const allowedTaskTypes = null;
export const listName = 'all';

const AllCommonTasks = commonTaskTemplate(listName, allowedTaskTypes);

export default AllCommonTasks;
